export default __webpack_public_path__ + "static/media/021_start_sound.cf0f2e3a.mp3";